// extracted by mini-css-extract-plugin
export default {"root":"sJcndyggzBbnSNEiWP5G","wrap":"EWLE59B_DSyaEdEzxl4f","filters":"YkB4s13nVsJNahzspPAQ","main":"JUQ9J8p_UuSp9e0Pdm5H"};